import css from 'styled-jsx/css';

const styles = css`:root {
  /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */
  --black: #000000;
  --dark-gray: #b3b3b3;
  --error: red;
  --success: #248647;
  --green: green;
  --lightgreen: lightgreen;
  --gray-1: #787778;
  --gray-2: #bbbbbb;
  --gray-2-5: #d8d8d8;
  --gray-3: #eeeeee;
  --gray-4: #f8f8f8;
  --gray-5: #fafafa;
  --gray-6: #ebebeb;
  --gray-footer: #4f4f4f;
  --gray-footer-text: #757575;
  --gray-black: #111111;
  --heading-gray: #505050;
  --border-gray: #c8c8c8;
  --gray-background: rgba(0, 0, 0, 0.2);
  --warning: #daaa00;

  --mmr-yellow: #f8e71c;
  --mmr-red: #b41f00;
  --module-gray: #f7f7f7;
  --module-white: #ffffff;
  --primary-bg: #eeeeee;
  --clear: transparent;

  --risk-high: #e37a00;
  --risk-low: #7c993f;
  --risk-med: #ffcc00;
  --text-fg: #3b3b3b;
  --text-header: #4c5a6a;
  --tooltip-header: #4c5a69;
  --warm-grey: #898989;
  --white: #ffffff;
  --border-line: #b8b8b8;
  --orange-button: #e17a17;

  --text-dark: #3b3b3b;
  --text-med: #4f4f4f;
  --text-light: #898989;
  --text-xlight: #c4c4c4;
  --text-disabled: #b1b1b1;

  --subtle-blue-gray: #f7f9fa;
  --trp-dark-blue: #004b71;
  --trp-light-blue: #eef7fa;
  --trp-bright-blue: #05c3de;
  --ice-blue: #24c0d8;
  --row-blue: #06c3df;
  --trp-dark-blue: #0063ad;
  --dark-blue: #054c70;
  --dark-blue-2: #043954;
  --navy-blue: #0a4c71;
  --trp-nav-dark-blue: #061937;
  --trp-bottom-footer-blue: #0c2a4d;
  --trp-link-blue: #80c8ff;
  --trp-tag-blue: #00cfec;

  --navy-gradient: linear-gradient(115deg, #054c70, #086ea1);

  /* NASU Specifc Colors */
  /* TODO [2020-08-05]: change these colors to EDDS approved colors if they are not already */
  --BYOP-header-grey: #f0f3f5;
  --BYOP-header-contents-grey: #f7f9fa;

  /* 2020 colors */
  --primary-blue: #086ea1;
  --brand-interactive-blue: #006894;
  --grey-text: #475359;
  --gray-back: #f1f1f1;
  --gray-morningstar: #6b7880;
  --gray-non-rated-star: #b4babf;
  --gray-risk-reward-bar: #e9edf0;
  --green-risk-reward-thumb: #7d9845;
  --yellow-risk-reward-thumb: #ffcf3d;
  --orange-risk-reward-thumb: #e17a17;
  --gray-header-bottom-border: #879199;
  --gray-disabled-button: #e1e5e8;
  --border-white: #d3d7da;
  --link-blue: #006894;
  --qv-header-bottom-border: #d7dbde;
  --required-error-msg: #cc1f1f;
  --no-funds-error-msg: #dd3636;

  /* Beacon colors */
  --beacon-primary: #8b57d9;
  --input-field-title: #3b4b59;
  --background-blue: #253746;
}
:root {
  --page-max-width: 1230px;
  --page-padding: 32px;
  --module-gutter: 24px;
  --half-gutter: calc(var(--module-gutter) / 2);
  --quarter-gutter: calc(var(--half-gutter) / 2);
  --module-padding: 24px;
  --mobile-padding: 4px;
  --min-content: min-content;

  /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */
  --element-spacing-1: 8px;
  --element-spacing-2: calc(var(--element-spacing-1) * 2);
  --element-spacing-3: calc(var(--element-spacing-1) * 3);
  --element-spacing-4: calc(var(--element-spacing-1) * 4);
  --element-spacing-5: calc(var(--element-spacing-1) * 5);
  --element-spacing-6: calc(var(--element-spacing-1) * 6);
  --element-spacing-7: calc(var(--element-spacing-1) * 7);
  --element-spacing-8: calc(var(--element-spacing-1) * 8);
  --element-spacing-9: calc(var(--element-spacing-1) * 9);
  --element-spacing-10: calc(var(--element-spacing-1) * 10);
  --element-spacing-11: calc(var(--element-spacing-1) * 11);

  --border-thin-width: 1px;
  --border-width: 2px;
  --border-radius: 5px;

  /* New II Design Pattern - Introduced 11-12-2019 */
  --page-focus-width: 544px;
  --help-focus-width: 328px;
}
:root {
  --xxxsmall-font: 10px;
  --xxsmall-font: 12px;
  --xsmall-font: 14px;
  --small-font: 16px;
  --med-font: 18px;
  --large-font: 20px;
  --xlarge-font: 24px;
  --xxlarge-font: 36px;
  --xxxlarge-font: 48px;
  --title-font: 18px;
  --label-sup-font: 100%;

  --h1-font: 32px;
  --h2-font: 20px;
  --p1: 16px;
  --p2: 14px;
  --caption-size: 12px;

  --h1-font-mobile: 24px;
  --h2-font-mobile: 18px;
  --p1-mobile: 16px;
  --p2-mobile: 14px;
  --caption-size-mobile: 12px;

  --roboto-flex-font: 'Roboto Flex', sans-serif;
  --sans-novus: 'Roboto Flex Novus';
  --condensed-font: 'Roboto Flex Condensed', 'Roboto Flex', sans-serif;
  --condensed-bold: 'Roboto Flex Condensed Bold', 'Roboto Flex Condensed',
    sans-serif;
  --serif-font: 'IBM Plex Serif', serif;
  --mono-font: 'Roboto Flex', sans-serif;

  --roboto-reg: 'Roboto Flex Reg', sans-serif;
  --roboto-italic: 'Roboto Flex Italic', sans-serif;
  --roboto-bold: 'Roboto Flex Bold', sans-serif;
  --roboto-light: 'Roboto Flex', sans-serif;
  --roboto-black: 'Roboto Flex Black', sans-serif;

  --rocky-reg: 'Rocky Reg', sans-serif;
  --rocky-light: 'Rocky Light', sans-serif;

  --regular-weight: 400;
  --bold-weight: 700;
  --light-weight: 100;
  --normal-weight: normal;

  --checkbox-height: 25px;
  --checkbox-width: 25px;
}
:root {
  --margin-bottom-fieldset: 0px;
}
.ocr-wizard-wrapper {
  background-color: #f7f9fa;
  padding: calc(8px * 2);
}
.ocr-wizard-wrapper :global(h1) {
  text-align: left;
}
.ocr-wizard-wrapper :global(fieldset) {
  border: none;
  padding-left: 0;
}
.ocr-wizard-section1 :global(label) {
  float: right;
}
.ocr-wizard-wrapper :global(label) {
  position: relative;
  bottom: 2px;
  margin-left: 8px;
}
.ocr-wizard-section2 :global(.options) {
  display: flex;
  flex-direction: column;
}
.ocr-wizard-section1 :global(.option) {
  display: inline-block;
  margin-right: 8px;
}
.ocr-wizard-section2 :global(.option) {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
}
.ocr-wizard-wrapper :global(.wrapper) {
  margin-bottom: 0px;
}
.ocr-wizard-wrapper :global(fieldset.vertical) {
  width: auto;
  margin-bottom: 0px;
}
.button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.special-text {
  margin-bottom: calc(8px * 2);
  color: red;
}
`;

export default styles;